import React from 'react'
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { RecordedSessionRoutes } from './Constants/routes';

const RecordedSessionsAll = () => {
  const match = useRouteMatch();

  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {RecordedSessionRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/recorded-sessions" />
      </Switch>
    </>
  )
}

export default RecordedSessionsAll;